import { ElementState } from "@creatomate/preview";

const findSkippedElements = (
  element: ElementState, newTime: number, trackEls: ElementState[]
): {
  skippedElementBackward?: ElementState; skippedElementForward?: ElementState;
} => {
  const endTime = element.localTime + element.duration;
  return {
    skippedElementBackward: trackEls?.find(te => te.localTime < endTime && te.localTime > newTime),
    skippedElementForward: trackEls?.find(te => te.localTime > endTime && te.localTime < newTime)
  };
};

export default findSkippedElements;
